import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const BottomBannerSkeleton = () => {
  return (
    <div className="ad-banner-container" style={{ background: "linear-gradient(135deg, #f0f0f0 0%, #e0e0e0 100%)" }}>
      <div className="ad-banner-content">
        <h2>
          <Skeleton width="60%" height={30} />
        </h2>
        <p>
          <Skeleton count={2} />
        </p>
        <div style={{ marginTop: "15px" }}>
          <Skeleton width={120} height={40} borderRadius={30} />
        </div>
      </div>
      <div className="ad-banner-image">
        <Skeleton height="100%" width="100%" />
      </div>
    </div>
  );
};

export default BottomBannerSkeleton;